export const limits = {
  min: 10,
  max: 1000,
  secs: 1,
  maxPerSlider: 500,
};

export enum Product {
  SaaS = 'SaaS',
  'Self-hosted' = 'Self-hosted',
}

export const APMHosts = {
  min: 10,
  max: 999,
  default: 10,
  optimal: 10,
};

export const IQMHosts = {
  min: 10,
  max: 999,
  default: 10,
  optimal: 10,
};

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30InstanaPE = '30AO8';

export const emailCOSJson = 'instanaPE.json';
